import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_SESSION_ID, SYSTEM_ID_SENIORITIES } from '../../../../core/constants';
import { registerActions } from '../../../../core/register/actions';
import { getSystemById, systemActions } from '../../../../core/system';
import { FormRegister } from './form-register';
import { Link } from 'react-router-dom';
import LoadingIndicator from '../../../components/loading-indicator';
import { passwordStrengthChecker } from '../../../../core/helper';
import trueLogoText from '../../../../assets/img/logo.svg'
import { WelcomeMessage } from '../WelcomeMessage';


const emailRegex = RegExp(
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
);

const RegisterPage = ({ seniorities, loadSystem, registerUser, register, resetError }) => {
    const list_seniorities = seniorities && seniorities.items;
    const [formErrors, setformErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        confirmEmail: '',
        alternativeEmail: '',
        confirmAlternativeEmail: '',
        password: '',
        confirmPassword: '',
        senioritySelect: ''
    });
    const [inputValues, setInputValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        confirmEmail: '',
        alternativeEmail: '',
        confirmAlternativeEmail: '',
        password: '',
        confirmPassword: '',
        senioritySelect: '',
        termsAndPrivacy: false
    })

    useEffect(() => {
        loadSystem(SYSTEM_ID_SENIORITIES)

        return () => {
            resetError()
        }
    }, [])

    const handleInputChange = async ({ target }) => {
        let { name, value } = target;

        switch (name) {
            case "firstName":
                formErrors.firstName =
                    value.length < 1 ? "Minimum 1 characters required" : "";
                break;
            case "lastName":
                formErrors.lastName =
                    value.length < 1 ? "Minimum 1 characters required" : "";
                break;
            case "email":
                formErrors.email = emailRegex.test(value)
                    ? ""
                    : "Invalid email address";
                formErrors.confirmEmail = (inputValues.confirmEmail && inputValues.confirmEmail !== value)
                    ? "Emails do not match"
                    : ""
                break;
            case "confirmEmail":
                let matchEmail = inputValues.email === value ? '' : 'Emails do not match';
                formErrors.confirmEmail = emailRegex.test(value)
                    ? matchEmail
                    : "Invalid email address";
                break;
            case "alternativeEmail":
                if (value) {
                    formErrors.alternativeEmail = emailRegex.test(value)
                        ? ""
                        : "Invalid email address";
                    formErrors.confirmAlternativeEmail = (inputValues.confirmAlternativeEmail && inputValues.confirmAlternativeEmail !== value)
                        ? "Emails do not match"
                        : ""
                } else {
                    formErrors.alternativeEmail = ''
                    formErrors.confirmAlternativeEmail = ''
                }
                break;
            case "confirmAlternativeEmail":
                if (inputValues.alternativeEmail) {
                    let matchAlternativeEmail = inputValues.alternativeEmail === value ? '' : 'Emails do not match';
                    formErrors.confirmAlternativeEmail = emailRegex.test(value)
                        ? matchAlternativeEmail
                        : "Invalid email address";
                }
                break;
            case "password":
                let passwordStrength = passwordStrengthChecker(value) === 'Too weak!' ? 'Too weak!' : ''
                formErrors.password = value.length < 8 ? "Minimum 8 characters required" : passwordStrength;

                if(inputValues.confirmPassword) {
                    formErrors.confirmPassword = inputValues.confirmPassword === value ? '' : 'Passwords do not match';
                }
                break;
            case "confirmPassword":
                formErrors.confirmPassword = inputValues.password === value ? '' : 'Passwords do not match';
                break;
            case "termsAndPrivacy":
                value = target.checked
                break;
            default:
                break;
        }

        setInputValues({
            ...inputValues,
            [name]: value
        });
    }

    useEffect(() => {
        if(register?.error?.data) {

        }
    }, [register?.error?.data])

    const onSubmitRegister = async (e) => {
        e.preventDefault();
        if (formValid()) {
            let newRegister = {
                email: inputValues.email,
                // alternative_email: inputValues.alternativeEmail,
                password: inputValues.password,
                first_name: inputValues.firstName,
                last_name: inputValues.lastName,
                seniority_id: inputValues.senioritySelect,
                accept_terms: inputValues.termsAndPrivacy
            }
            registerUser({ newRegister })
        }
    }

    const formValid = () => {
        let valid = true;
        let keysNotRequired = ['alternativeEmail', 'confirmAlternativeEmail']

        // validate the form was filled out
        Object.keys(inputValues).forEach((key) => {
            if (!keysNotRequired.includes(key)) {
                inputValues[key] == '' && (valid = false);
            }
        })

        if (inputValues.alternativeEmail && !inputValues.confirmAlternativeEmail) valid = false

        return valid;
    };

    return (
        <Container fluid="xl" className='minvh-100 px-0 px-md-3'>
            <div className="d-md-flex align-items-md-stretch justify-content-md-center minvh-100">
                <WelcomeMessage displayClass={'d-none d-md-block'}/>
                <div className="col-login p-md-4 align-self-center">
                    <div className='bg-white p-4 col-login-form d-flex flex-column h-100'>
                        <div className="content-login mb-auto">
                            <img src={trueLogoText} alt="True Advance" className='logo mb-4'/>
                            <h3 className="libre-caslon-text-regular mb-3">Create an Account</h3>
                            <FormRegister
                                inputValues={inputValues}
                                handleInputChange={handleInputChange}
                                listSeniorities={list_seniorities}
                                onSubmitRegister={onSubmitRegister}
                                formErrors={formErrors}
                                formValid={formValid}
                            />
                            {register.error.email && <div>{register.error.email[0]}</div>}

                            {register.isPending && <LoadingIndicator />}
                            <div className='pt-4'>
                                <p className='text-center mb-0'>Already have an account? <Link to={'/login'} className="text-danger font-weight-semibold">Log in</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

const mapStateToProps = (state, props) => {
    const seniorities = getSystemById(state, SYSTEM_ID_SENIORITIES);
    const { register } = state;
    return {
        seniorities,
        register
    };
};

const mapDispatchToProps = {
    loadSystem: systemActions.loadSystem,
    registerUser: registerActions.createUser,
    resetError: registerActions.resetError
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterPage);
